import React, { useEffect } from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { ROLE_PERMISSIONS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';
import { GET_LOCATION_DETAIL_MOBILE, MODIFY_LOCATION_MOBILE, SUBSCRIBE_TO_LOCATION_MOBILE } from '../../graphql/location';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import LocationDetail from './LocationDetail';

const LocationDetailView = ({ hideDirections = false, locationId }) => {
	const navigation = useNavigation();
	const { hasPermission } = useUserContext();
	const styles = useThemedStyles(createStyles);

	// don't add deps to avoid infinite loop
	useEffect(() => {
		if (hasPermission && navigation) {
			navigation.setOptions(hasPermission(ROLE_PERMISSIONS.ADD_EDIT_TICKETS));
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<View style={styles.container}>
			<LocationDetail
				id={locationId}
				query={GET_LOCATION_DETAIL_MOBILE}
				subscription={SUBSCRIBE_TO_LOCATION_MOBILE}
				modifyMutation={MODIFY_LOCATION_MOBILE}
				hideDirections={hideDirections}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		backgroundColor: colors.canvas,
		flex: 1,
	},
});

export default LocationDetailView;
